import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import SMS from '../../models/SMS';

async function getLatestSMS(
  subscriptionApiKey?: string | null
): Promise<{
  sms: SMS;
}> {
  try {
    const db = firestore;
    const collectionSMS = collection(db, FirestoreCollections.sms);
    const subscriptionDoc = await getDocs(
      query(
        collectionSMS,
        where('id_api_key', '==', subscriptionApiKey),
        orderBy('created', 'asc'),
        limit(1)
      )
    );

    if (subscriptionDoc.docs.length < 1) {
      throw new GetLatestSMSFailure();
    }

    const sms = SMS.fromFirestore(subscriptionDoc.docs[0]);

    return {
      sms
    };
  } catch (e) {
    console.log('error: ', e);
    throw new GetLatestSMSFailure();
  }
}

export class GetLatestSMSFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getLatestSMS;
